<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "QualityReportLayout"
    }

</script>

<style scoped>

</style>
